import { saveAs } from 'file-saver'
import { convertBase64ToByteArray } from './convertBase64ToByteArray'

export const downloadFile = (
  file: string,
  nameFile: string,
  useFileExtension = false,
) => {
  const blobFile = convertBase64ToByteArray(file, true)
  const blob = new Blob([blobFile], { type: 'application/pdf' })
  const uri = window.URL.createObjectURL(blob)

  saveAs(uri, `${nameFile}${useFileExtension ? '' : '.pdf'}`)
}
